import React from "react";

import { Box, Typography, Button } from "@mui/material";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// Shared "Showing X to Y of Z results" + prev/next pagination footer,
// used by DataTable and any other paginated list.
function Pagination({ page, totalPages, onPageChange, rangeStart, rangeEnd, totalCount }) {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
      <Typography fontSize={13} color="text.secondary">
        Showing {totalCount === 0 ? 0 : rangeStart} to {rangeEnd} of {totalCount} results
      </Typography>

      <Box display="flex" alignItems="center" gap={1}>
        <Button size="small" disabled={page === 1} onClick={() => onPageChange(page - 1)}>
          <ChevronLeftIcon />
        </Button>

        <Button variant="contained" size="small" sx={{ minWidth: 32 }}>
          {page}
        </Button>

        <Button
          size="small"
          disabled={page === totalPages || totalPages === 0}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRightIcon />
        </Button>
      </Box>
    </Box>
  );
}

export default Pagination;
